<template>
  <mdb-container class="gp-has-header">
    <div v-if="subscription" class="text-left">
      <mdb-btn size="sm" rounded icon="arrow-left"
               @click="$router.push($route.query.return)"
               v-if="$route.query.return">
        Back
      </mdb-btn>
      <mdb-btn size="sm" rounded icon="user"
               @click="$router.push('/users/' +subscription.userId)"
               v-if="! $route.query.return || $route.query.return.indexOf('/users/') < 0">
        User Info
      </mdb-btn>

      <mdb-card class="mb-4" v-if="subscription.pendingChange">
        <mdb-card-header class="warning-color text-white">
          <h3>
            There is a pending subscription change
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <div>
            <b>Change type: </b> {{subscription.pendingChange.changeType}}
          </div>
          <div v-if="subscription.pendingChange.changeType != 'CANCELLATION'">
            <b>New plan: </b> {{subscription.pendingChange.planName}}  ( {{subscription.pendingChange.term}} )
          </div>
          <div v-if="subscription.pendingChange.upgradeAmount > 0">
            <b>Charge: </b> {{subscription.pendingChange.currencySymbol}}{{subscription.pendingChange.upgradeAmount}} {{subscription.pendingChange.currencyCode}}
          </div>
        </mdb-card-body>
        <mdb-card-footer>
          <mdb-btn @click="removePendingChange" icon="times-circle" color="danger">Remove Pending Change</mdb-btn>
        </mdb-card-footer>
      </mdb-card>


      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h3>
            <avatar :avatar="subscription.userAvatar"/>
            Current Subscription Information
          </h3>
          <mdb-badge color="danger" v-if="subscription.billingSuspension">Billing Suspension</mdb-badge>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-input label="Name" v-model="subscription.userName" disabled/>
          <mdb-input label="Email" v-model="subscription.userEmail" disabled/>
          <mdb-input label="Plan" v-model="subscription.planName" disabled/>
          <mdb-input label="Price" v-model="subscription.priceFormatted" disabled/>
          <mdb-input label="Term" v-model="subscription.term" disabled/>
          <mdb-input label="Last Billed" v-model="subscription.lastBilledDisplay" disabled/>
          <mdb-input label="Paid Through" v-model="subscription.paidThroughDisplay" disabled/>
          <mdb-btn @click="editSubscription" icon="pencil">Edit</mdb-btn>
          <mdb-btn @click="deleteSubModal=true" icon="trash" color="danger">Delete</mdb-btn>
          <mdb-btn @click="toggleSuspension" icon="minus-circle" color="warning">
            <span v-if="subscription.billingSuspension">Remove Suspension</span>
            <span v-if="!subscription.billingSuspension">Add Billing Suspension</span>
          </mdb-btn>
        </mdb-card-body>
      </mdb-card>

        <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h3>
            Current Charges
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Date</th>
                <th>Base Charge</th>
                <th>Discounts Applied</th>
                <th>Total Due</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="charge in subscription.charges" :key="charge.id">
                <td>{{ charge.date }}</td>
                <td>{{ charge.baseCharge }}</td>
                <td>{{ charge.discountApplied }}</td>
                <td>{{ charge.totalDue }}</td>
                <td>
                  <mdb-btn floating size="sm" tag="a" icon="pencil" title="Edit" aria-label="Edit" @click="editCharge(charge)"/>
                  <mdb-btn floating size="sm" tag="a" icon="credit-card" color="warning" title="Charge Now" aria-label="Charge Now" @click="execCharge(charge)"/>
                  <mdb-btn floating size="sm" tag="a" icon="trash" color="danger" title="Delete" aria-label="Delete" @click="deleteCharge(charge)"/>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h3>
            Payment Processor Information
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Processor</th>
                <th>Customer ID</th>
                <th>Payment Methods</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="cust in subscription.customers" :key="cust.id">
                <td>{{ cust.processor }}</td>
                <td>{{ cust.customerId }}</td>
                <td>
                  <p v-for="method in cust.methods" :key="method.id">
                    <span class="text-info">{{ method.type }}</span> **** **** **** {{ method.ccLast4 }} <br/>
                    <span class="text-info">Expires</span> {{ method.expires }} <br/>
                    <span class="text-info">Source</span> {{ method.paymentSourceId }}
                  </p>

                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4" v-if="subscription.issues && subscription.issues.length>0">
        <mdb-card-header class="secondary-color">
          <h3>
            Subscription Problems/Issues
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Date</th>
                <th>Message</th>
                <th>Original Charge</th>
                <th>New Charge</th>
                <th>Prorated Amount</th>
                <th>Total Groups</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="issue in subscription.issues" :key="issue.id">
                <td>{{ issue.date }}</td>
                <td>{{ issue.message }}</td>
                <td>{{ issue.originalCharge }}</td>
                <td>{{ issue.newCharge }}</td>
                <td>{{ issue.proratedAmount }}</td>
                <td>{{ issue.totalGroups }}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h3>
            Transaction History
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-btn @click="addTransaction" icon="plus-circle" size="sm" rounded>Add</mdb-btn>
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Confirmation</th>
                <th></th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="trans in subscription.transactions" :key="trans.id">
                <td>{{ trans.date }}</td>
                <td>{{ trans.description }}</td>
                <td class="text-right">{{ trans.amount }}</td>
                <td>{{ trans.confirmation}}</td>
                <td><mdb-btn size="sm" floating tag="a" icon="trash" color="danger" @click="deleteTransaction(trans)"></mdb-btn></td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>


    </div>

    <mdb-modal v-if="showEditModal" @close="showEditModal = false">
      <mdb-modal-header class="secondary-color">
        <h5>Edit Subscription</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <gp-select :dataObj="editing" :possible-values="subscription.plans"
                   label="Plan" propertyName="planId"/>
        <div class="md-form">
          <div>
            <!--<datetime :auto="true"
                      :format="userDetails.dateFormat"
                      :use12-hour="userDetails.timeFormat=='AM/PM'" :valueZone="userDetails.timezone"
                      :weekStart="userDetails.mondayFirst ? 1 : 7"
                      inputId="paidThrough" type="date"
                      v-model="editing.paidThrough"/> -->
            <date-picker
              type="date"
              :format="userDetails.dateFormat.toUpperCase()"
              value-type="date"
              editable
              clearable
              v-model="editing.paidThrough"
              />

            <label class="active mr-5">Paid Through</label>
          </div>
        </div>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn size="sm" rounded color="success" @click="saveSubscription" icon="save">Save</mdb-btn>
        <mdb-btn size="sm" rounded color="warning" @click="showEditModal=false" icon="times-circle">Cancel</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-modal v-if="showChargeEditModal" @close="showChargeEditModal = false">
      <mdb-modal-header class="secondary-color">
        <h5>Edit Charge</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input type="number" :step="0.01" :min="0" v-model="editing.baseChargeRaw" label="Base Charge"/>
        <mdb-input type="number" :step="0.01" :min="0" v-model="editing.additionalGroupsChargeRaw" label="Additional Groups Charge"/>
        <mdb-input type="number" :step="0.01" :min="0" v-model="editing.discountAppliedRaw" label="Discount"/>

      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn size="sm" rounded color="success" @click="saveCharge" icon="save">Save</mdb-btn>
        <mdb-btn size="sm" rounded color="warning" @click="showChargeEditModal=false" icon="times-circle">Cancel</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>


    <yes-no-modal @yes="doDeleteCharge"
                  @no="deleteChargeModal=false"
                  v-if="deleteChargeModal"
                  question="Delete this pending charge?"
                  additional-text="Charges are generated by the system. If you don't change the underlying reason for a charge, it will be re-generated."
                  />

    <yes-no-modal @yes="doDeleteSub"
                  @no="deleteSubModal=false"
                  v-if="deleteSubModal"
                  question="Delete this subscription?"
    />

    <yes-no-modal v-if="showDeleteTransConfirm" @yes="doDeleteTrans" @no="showDeleteTransConfirm=false"/>

    <mdb-modal v-if="recordModal" @close="recordModal=false">
      <mdb-modal-header class="secondary-color"><h4>New Transaction</h4></mdb-modal-header>
      <mdb-modal-body>
        <div class="md-form">
          <div>
            <datetime v-model="editingTransaction.date"
                      :auto="true"
                      :format="userDetails.dateFormat"
                      :valueZone="userDetails.timezone" :weekStart="userDetails.mondayFirst ? 1 : 7">
              :zone="userDetails.timezone" :format="userDetails.dateFormat">
            </datetime>
            <label class="active mr-5">Date</label>
          </div>
        </div>

        <mdb-input v-model="editingTransaction.description" label="Description"
                   placeholder="Transaction description. Optional."
                   type="text"></mdb-input>
        <mdb-input v-model="editingTransaction.amount" :separator="userDetails.decimalSeparator" :step="0.01"
                   label="Amount"
                   minus placeholder="Amount" type="number"></mdb-input>
        <div class="md-form">
          <select id="currencyCode"
                  v-model="editingTransaction.currencyCode"
                  class="browser-default gp-custom-select">
            <option v-for="curr in currencies" :value="curr">{{ curr }}</option>
          </select>
          <label class="active mr-5">Currency</label>
        </div>
        <mdb-input v-model="editingTransaction.confirmationCode" label="Confirmation"
                   placeholder="Enter optional confirmation code, check number, etc."
                   type="text"></mdb-input>

        <div class="md-form">
          <select id="transId"
                  v-model="editingTransaction.source"
                  class="browser-default gp-custom-select">
            <option v-for="opt in sources" :value="opt">{{ opt }}</option>
          </select>
          <label class="active mr-5">Source</label>
        </div>

        <mdb-btn v-if="editingTransaction.date && editingTransaction.amount" icon="save" @click="saveTransaction">Save
        </mdb-btn>
        <mdb-btn icon="ban" @click="cancelTransaction">Cancel</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>



  </mdb-container>
</template>

<script>

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
//import {Datetime} from 'vue-datetime'
import {Datetime} from 'vue-datetime'
import moment from 'moment';
import DatePicker from 'vue2-datepicker'
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";
import gpSelect from "../common/GPSelect";
import YesNoModal from "../common/YesNoModal";
import 'vue2-datepicker/index.css';

export default {
  name: 'admin-subscription',
  components: {
    Avatar,
    mdbContainer, mdbBtn,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardFooter,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    gpSelect,
    //Datetime,
    DatePicker,
    YesNoModal,
    Datetime
  },
  computed: {
    config: function () {
      return this.$store.state.settings
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
  },
  data() {
    return {
      subscription: null,
      showEditModal: false,
      showChargeEditModal: false,
      editing: null,
      deleteChargeModal: false,
      deleteSubModal: false,
      deleteCandidate: null,
      editingTransaction: null,
      recordModal: false,
      showDeleteTransConfirm: false,
      countries: [],
      currencies: [],
      sources: ["Check", "Cash", "Credit Card", "PayPal", "Stripe", "Venmo", "Other", "Adjustment"],
    }
  },
  mounted() {
    document.title = "User Subscription"
    this.loadSubscription()
    this.loadCountries()
  },
  methods: {
    addTransaction() {
      this.editingTransaction = {
        allowDelete: false
        , amount: null
        , confirmationCode: ""
        , date: moment().format()
        , description: ""
        , displayDate: ""
        , source: ""
        , currencyCode: this.config.defaultCurrency
        , id: null
      }
      console.log("Date is " + this.editingTransaction.date)
      this.recordModal = true
    },
    deleteTransaction: function (trans) {
      this.deleteCandidate = trans
      this.showDeleteTransConfirm = true
    },
    cancelTransaction() {
      this.recordModal = false
    },
    saveTransaction() {
      this.recordModal = false
      this.$store.dispatch("setExecuting", true)
      api.put("/user/transaction/" + this.subscription.userId,
              this.editingTransaction).then(
        (results) => {
          this.loadSubscription()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 8000})
          this.recordModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doDeleteTrans: function () {
      this.showDeleteTransConfirm = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/user/transaction/" + this.deleteCandidate.id).then(
        (results) => {
          this.loadSubscription()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    removePendingChange: function () {
      this.showDeleteTransConfirm = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/user/pendingChange/" + this.subscription.pendingChange.id).then(
        (results) => {
          this.subscription.pendingChange = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    loadSubscription() {
      this.$store.dispatch("setExecuting", true)
      api.get("/subscription/show/" + this.$route.params.id).then(
        (results) => {
          this.subscription = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
                  this.$store.dispatch("setExecuting", false)
                }
      )
    },
    editCharge(charge) {
      this.editing = JSON.parse(JSON.stringify(charge))
      this.showChargeEditModal = true
    },
    deleteCharge(charge) {
      this.deleteCandidate = charge
      this.deleteChargeModal = true
    },
    saveCharge() {
      this.showChargeEditModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/subscription/charge/", this.editing).then(
        (results) => {
          this.$notify.success({
                                 message: "Deleted.",
                                 timeOut: 5000
                               })
          this.subscription = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    execCharge(charge) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/execCharge", {id: charge.id}).then(
        (results) => {
          this.loadSubscription()
        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    doDeleteCharge() {
      this.deleteChargeModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/subscription/charge/" + this.deleteCandidate.id).then(
        (results) => {
          this.$notify.success({
                                 message: "Deleted.",
                                 timeOut: 5000
                               })
          this.subscription = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editSubscription() {
      this.editing = JSON.parse(JSON.stringify(this.subscription))
      if (this.editing.paidThrough) this.editing.paidThrough = new Date(this.editing.paidThrough)
      this.showEditModal = true

    },
    saveSubscription() {
      this.$store.dispatch("setExecuting", true)
      this.showEditModal = false
      api.post("/subscription/update", { subscription: this.editing.id, planId: this.editing.planId, paidThrough: this.editing.paidThrough}).then(
        (results) => {
          this.$notify.success({message: "Subscription saved successfully.", timeOut: 2000})
          this.subscription = results.data
        },
        (error) => {
          this.showEditModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doDeleteSub() {
      this.$store.dispatch("setExecuting", true)
      this.deleteSubModal = false
      api.delete("/subscription/delete/" + this.subscription.id).then(
        (results) => {
          this.$notify.success({message: "Subscription deleted successfully.", timeOut: 2000})
          if (! this.$route.query.return) this.$router.push("/user/subscription")
          else this.$router.push(this.$route.query.return)
        },
        (error) => {
          this.showEditModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleSuspension() {
      this.$store.dispatch("setExecuting", true)
      api.post("/subscription/toggleSuspension/" + this.subscription.id, {}).then(
        (results) => {
          this.$notify.success({message: "Suspension status updated.", timeOut: 2000})
          this.subscription.billingSuspension = !this.subscription.billingSuspension
        },
        (error) => {
          this.showEditModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadCountries() {
      api.get("/public/countryList").then(
        (results) => {
          this.countries = results.data
          for (const country of this.countries) {
            if (! this.currencies.includes(country.currencyCode)) this.currencies.push(country.currencyCode)
          }
        },
        (error) => {
          this.$notify.error({message: "Error fetching countries.", timeOut: 3000})
        }).then(() => {
      })
    }
  }
};
</script>

<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>

